import CardRecomendado from './CardRecomendado';

export default CardRecomendado;